import { useEffect, useRef, useState } from "react";
import { Dialog, DialogTitle, DialogContent, Table, TableBody, TableRow, TableCell, Button, Typography, Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import type { RootState, OngoingGame } from '../../types/store';
import AppUtils from '../../utils/app-utils';
import AppActions from '../../actions/app-actions';

export default function OngoingGames() {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const ongoingGames = useSelector((state:RootState) => state.ui.ongoingGames);
    const translate = useSelector((state:RootState) => state.ui.language.ongoing);
    const navigate = useNavigate();
    
    const hasFired = useRef(false);
    useEffect(() => {
        if(!hasFired.current) {
            validateCookies();
        }
        
        hasFired.current = true;
    }, []);
    
    useEffect(() => {
        if(ongoingGames.length > 0)
        {
            setOpen(true);
        }
        else
        {
            setOpen(false);
        }
    }, [ongoingGames]);
    
    function validateCookies() {
        dispatch(AppActions.CookieValidateClear({}));
        AppUtils.log("[Ongoing]", AppUtils.getAllCookies());
        let x = AppUtils.getAllCookies();
        let cookie_array = [];
        for(var a in x) {
            if(a.substring(0, 11) === "MOES_LOBBY_") {
                let cookie_lobby = parseInt(a.substring(11));
                let cookie_cookie = x[a];
                AppUtils.log("Lobby", cookie_lobby, "has cookie", cookie_cookie);
                cookie_array.push({ lobby: cookie_lobby, cookie: cookie_cookie });
            }
        }
        if(cookie_array.length > 0) {
            dispatch(AppActions.CookieValidate({cookies: cookie_array}));
        }
    }
    
    function onLeaveSilent(lobby:OngoingGame) {
        AppUtils.log("[Silent] Leaving lobby", lobby.lobby);
        let c = AppUtils.getCookie(lobby.lobby);
        if(c !== undefined) {
            AppUtils.log("[Silent] We also have a cookie", c);
            dispatch(AppActions.LeaveLobbySilent({lobby: lobby.lobby, cookie: c}));
        }
    }
    
    function onJoinLobby(lobby:OngoingGame) {
        navigate(`/lobby/${lobby.lobby}`);
    }
    
    return (
        <Dialog open={open} maxWidth="sm" fullWidth>
            <DialogTitle>{translate.ongoing}</DialogTitle>
            <DialogContent>
                <Table>
                    <TableBody>
                        {ongoingGames.map((lobby) => (
                            <TableRow key={lobby.lobby}>
                                <TableCell>
                                    <Typography>{lobby.lobby} ({lobby.players} player{lobby.players !== 1 ? 's' : ''})</Typography>
                                </TableCell>
                                <TableCell align="right">
                                    <Stack direction="row" spacing={2} mt={2}>
                                        <Button variant="contained" color="error" onClick={() => onLeaveSilent(lobby)}>Leave</Button>
                                        <Button variant="contained" onClick={() => onJoinLobby(lobby)}>Join lobby</Button>
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </DialogContent>
        </Dialog>
    );
  
}
